import React from 'react'
import View from './View/View'

function RolesIndex() {
  return (
    <div>
      <View/>
    </div>
  )
}

export default RolesIndex
